import { useQueryParam } from "@/hooks/useQueryParam";

export const useShowFlatMobileFirstFromQueryParam = () =>
  useQueryParam("showFlatMobileFirst");
